import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CONST } from '../utils';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PrintIcon from '@mui/icons-material/Print';
import HandymanIcon from '@mui/icons-material/Handyman';
import Camera from 'react-dom-camera';
import { Box, Typography, Divider, Button } from '@mui/material';
import { Testing } from '../controllers';
import { TokenValidator } from '../utils';

export default function Landing() {
    document.title = 'TjBaGeneral';

    const nav = useNavigate();
    const [showFgs, setShowFgs] = React.useState(true);

    React.useEffect(() => {
        const checkFgsAccess = async () => {
            const token = await TokenValidator.GetInternalUser();
            if (!token) return setShowFgs(true);
            try {
                const valid = await TokenValidator.ValidTokenDate(token);
                const decoded = valid ? await TokenValidator.SimplifyToken(token) : null;
                setShowFgs(!decoded || (Number(decoded.roles) & 4) === 4);
            } catch (_) {
                setShowFgs(true);
            }
        };
        checkFgsAccess();
    }, []);

    const handleSelection = async(path) => {
        nav(path);
    }

    const clearMemory = async() => {
        localStorage.clear();
    }

    const manual = () => {
        var video = document.getElementById('vid');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.style.width = '600px';
        video.style.height = '600px';

        var facingMode = "environment";
        var constraints = {
        audio: false,
        video: {
        facingMode: facingMode
        }
        };

        navigator.mediaDevices.getUserMedia(constraints).then(function success(stream) {
        video.srcObject = stream;
        });
        
    }

    const manualOff = async() => {
        const videoElement = document.getElementById('vid');
        videoElement.pause();
        const stream = videoElement.srcObject;
        const tracks = stream.getTracks();
        videoElement.pause();
        
        tracks.forEach(x => {
            x.disable = true;
            x.stop();
        });

        videoElement.srcObject =null;
    }

    const manualFoto = async() => {
        const video = document.getElementById('vid');
        const canvas = document.getElementById('canvas');
        const context = canvas.getContext('2d');

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
            if (blob) {
                handleManual(blob);
            } else {
                console.error("Failed to create blob from canvas.");
            }
        }, 'image/png');
    }

    const handleManual = async(blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.split(';base64,').pop();
            console.log(base64String);
        };
        await reader.readAsDataURL(blob);
    }

    const handleRequest = async(buffer) => {
        const key = 'eyJhY2Nlc3NfdG9rZW4iOiJ5YTI5LkEwQVRrb0NjNGZPQlc0cUt2eDc5TDRFemxoLTU2Mk5SRUdNaTktS1BkVTdNRktOZExHX3ZSX1o4czA1ZHZKU1B5UWVQcENXRjBvS0JTaDc4Nms2T0tOZDJ5YjJRdk5ERVJqQXlJU3NKc043cjlvTEdENWZDMUtRSmxSaHRxcU5xaU5CVUhMSm90eW4wLU9udDJXOW1jdVFOTzNGbmYyNXdYaU4xY3F0UjdQc3BFeTJYSXNSdjV4cEhnVGpjNFFJYVdvck1Ic2RUQ2JybndiOXhKQ1RKTW03V2xBSkI1WUl4aV9jbTVwMmZ3ZEI1d1ZZalQyNGxLTHY1SkNoSTZham5YYWtyQVV6bjM4N3ZaT3dOQjhxSktYenUtYkRJMzhhQ2dZS0FhOFNBUk1TRlFIR1gyTWlfSEdLRWctMl9VeUxvcE9SbWwzVzZ3MDI5MSIsInNjb3BlIjoiaHR0cHM6Ly93d3cuZ29vZ2xlYXBpcy5jb20vYXV0aC9kcml2ZS5maWxlIGh0dHBzOi8vd3d3Lmdvb2dsZWFwaXMuY29tL2F1dGgvc3ByZWFkc2hlZXRzIGh0dHBzOi8vd3d3Lmdvb2dsZWFwaXMuY29tL2F1dGgvZHJpdmUiLCJ0b2tlbl90eXBlIjoiQmVhcmVyIiwiZXhwaXJ5X2RhdGUiOjE3NzM5NDYxNjQ1ODJ9';
        const data = new FormData();
        data.append('pic', buffer);
        data.append('data', key);

        const response = await Testing.t001(data);
        console.log(response);
    }

    return (
        <Box
            sx={{
                display:'flex',
                flexDirection:'column',
            }}
        >
            <Box
                sx={{
                    padding: 2,
                    marginInline: 8,
                    display:'flex',
                    flexDirection:'column',
                }}
            >
                <Typography variant='h3'>TJ BA General</Typography>
                <Typography variant='body2'>Tijuana Site MES (Manufacturing Execution System) web management and production control portal</Typography>
            </Box>

            <Box
                sx={{
                    display:'flex',
                    flexDirection:'row',
                    width: '100%',
                    flexWrap: 'wrap',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                {/* <Button onClick={manual}>Camara On</Button>
                <Button onClick={manualOff}>Camara Of</Button>
                <Button onClick={manualFoto}>pic</Button>
                <video id='vid' autoPlay/>
                <canvas id="canvas" style={{display: 'none'}}></canvas> */}

                {CONST.LANDING_ROUTES.filter(route => !['/fgsmanagement','/trackingaccess','/shippinglabelmanagement'].includes(route.path) || showFgs).map((route) => (
                    <Button 
                        key={route.path}
                        variant='contained' 
                        sx={{ 
                            borderInlineColor:'#fff', 
                            border:2, 
                            borderRadius:2,
                            width: '30%',
                            height: '15vh',
                            margin: 2
                        }} 
                        onClick={() => handleSelection(route.path)}
                        startIcon={route.path === '/fgsmanagement' ? <SettingsApplicationsIcon /> : route.path === '/trackingaccess' ? <VpnKeyIcon /> : route.path === '/shippinglabelmanagement' ? <LocalShippingIcon /> : route.path === '/bomprinting' ? <PrintIcon /> : route.path === '/pmlabeling' ? <HandymanIcon /> : undefined}
                    >
                        <Box>
                            <Typography>{route.name}</Typography>
                            {route.description && <Typography variant='caption' component='div'>{route.description}</Typography>}
                        </Box>
                    </Button>
                ))}

                
            </Box>
            
            <br/>

            <Box
                sx={{
                    padding: 1,
                    display:'flex',
                    flexDirection:'row',
                    alignItems: 'center'
                }}
            >
                <Button 
                    sx={{ 
                        borderInlineColor:'#fff', 
                        border:2, 
                        borderRadius:2,
                        marginRight: 12
                    }} 
                    onClick={clearMemory}
                    startIcon={<CleaningServicesIcon />}
                >
                    Clear Memory
                </Button>
                
                <a  href='/terms'>Privacy Policy</a>
            </Box>

        </Box>
    );
}
